import React from 'react';
interface Props {
  fillColor?: string;
}
function DigestiveIcon({ fillColor = '#17385D' }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none">
      <g clipPath="url(#clip0_851_3307)">
        <path
          d="M5.75 0.75C5.75 0.334375 5.41563 0 5 0C4.58437 0 4.25 0.334375 4.25 0.75V3C4.25 5.07188 5.92812 6.75 8 6.75H8.00625C8 6.83125 8 6.91563 8 7V9C8 10.2437 6.99375 11.25 5.75 11.25H3.75C1.67812 11.25 0 12.9281 0 15V15.25C0 15.6656 0.334375 16 0.75 16C1.16562 16 1.5 15.6656 1.5 15.25V15C1.5 13.8969 2.39687 13 3.5 13C3.8 13 4.09375 13.1094 4.45625 13.3469C4.73125 13.525 4.99062 13.7406 5.29688 13.9937C5.42812 14.1 5.56563 14.2156 5.71875 14.3375C6.70625 15.125 7.99687 16 10 16C13.3125 16 16 13.3125 16 10V7C16 4.79063 14.2094 3 12 3C10.4187 3 9.05 3.91875 8.40312 5.25H8C6.75625 5.25 5.75 4.24375 5.75 3V0.75ZM6.3125 12.8844C6.25 12.8344 6.1875 12.7812 6.125 12.7312C7.56875 12.5875 8.76875 11.625 9.2625 10.3156C9.64375 10.1 9.96875 10.0656 10.2844 10.1094C10.6719 10.1625 11.0625 10.3313 11.5688 10.5594L11.6062 10.5781C12.0687 10.7844 12.6406 11.0406 13.2625 11.1281C13.6219 11.1781 13.9906 11.1687 14.3687 11.0813C13.8875 13.0437 12.1125 14.5 10 14.5C8.50313 14.5 7.54375 13.875 6.65625 13.1656C6.54688 13.0781 6.43125 12.9844 6.31563 12.8875L6.3125 12.8844ZM14.5 9.425C14.1125 9.64688 13.7844 9.68125 13.4656 9.6375C13.0781 9.58437 12.6875 9.41562 12.1812 9.1875L12.1438 9.16875C11.6813 8.9625 11.1094 8.70625 10.4875 8.61875C10.1656 8.575 9.8375 8.575 9.5 8.64062V6.99375C9.5 5.6125 10.6187 4.49375 12 4.49375C13.3813 4.49375 14.5 5.6125 14.5 6.99375V9.41875V9.425Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_851_3307">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default DigestiveIcon;
